const ShipmentInsurances = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]" />
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Shipment Insurance (CVI)
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              The Customer Voluntary Insurance provides indemnity to the insured
              in case of shipment loss, shortage and/or damage due to an
              accident or a natural calamity.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Several cover options are available such as, with liability for
              all risks, with liability for particular average, or without
              responsibility for damage unless crashed.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img
              src="/DomesticScrollingBanner/customerinsurance.jpg"
              alt=""
              className="rounded-md max-w-[100%]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ShipmentInsurances;
